/**
 * Capacity & timing edit section for the venue page Details tab. The
 * FareHarbor location ID is shown read-only; it is not patchable.
 */
import { Field } from '../venueCreateFields';

import { EditSection } from './EditSection';
import { ReadGrid } from './ReadGrid';
import type { SectionProps } from './section-props';
import { Input, useFormDraft } from './sectionHelpers';

const toInt = (s: string, fallback: number) => {
  const n = Number.parseInt(s, 10);
  return Number.isFinite(n) ? n : fallback;
};

export function CapacitySection({ venue, readOnly, save }: SectionProps) {
  const seed = {
    maxCapacity: String(venue.maxCapacity),
    setup: String(venue.setupTimeMinutes),
    cleanup: String(venue.cleanupTimeMinutes),
  };
  const { draft, setField, reset } = useFormDraft(seed, venue.updatedAt);

  return (
    <EditSection
      title="Capacity & timing"
      readOnly={readOnly}
      onCancel={reset}
      onSave={() =>
        save({
          maxCapacity: toInt(draft.maxCapacity, venue.maxCapacity),
          setupTimeMinutes: toInt(draft.setup, venue.setupTimeMinutes),
          cleanupTimeMinutes: toInt(draft.cleanup, venue.cleanupTimeMinutes),
        })
      }
      view={
        <ReadGrid
          cols={3}
          rows={[
            { label: 'Max capacity', value: venue.maxCapacity, mono: true },
            { label: 'Setup', value: `${venue.setupTimeMinutes} min`, mono: true },
            { label: 'Cleanup', value: `${venue.cleanupTimeMinutes} min`, mono: true },
            {
              label: 'FareHarbor location ID',
              value: venue.fareharborLocationId,
              mono: true,
              full: true,
            },
          ]}
        />
      }
      form={
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: 12 }}>
          <Field label="Max capacity" required>
            <Input mono value={draft.maxCapacity} onChange={(v) => setField('maxCapacity', v)} />
          </Field>
          <Field label="Setup (min)">
            <Input mono value={draft.setup} onChange={(v) => setField('setup', v)} />
          </Field>
          <Field label="Cleanup (min)">
            <Input mono value={draft.cleanup} onChange={(v) => setField('cleanup', v)} />
          </Field>
        </div>
      }
    />
  );
}
